export default {
    "export": {
        "library_folder": {
            "class": "app\\build\\smz\\exportImport\\services\\FolderExportService",
            "permissions": []
        },
        "card": {
            "class": "app\\build\\smz\\exportImport\\services\\CardExportService",
            "permissions": []
        },
        "cardKpi": {
            "class": "app\\build\\smz\\exportImport\\services\\CardKpiExportService",
            "permissions": []
        },
        "cards": {
            "class": "app\\build\\smz\\exportImport\\services\\CardsExportService",
            "permissions": []
        },
        "calibration_table": {
            "class": "app\\build\\smz\\exportImport\\services\\CalibrationTableExportService",
            "permissions": []
        },
        "successors": {
            "class": "app\\build\\smz\\exportImport\\services\\SuccessorsExportService",
            "permissions": []
        },
        "users": {
            "class": "app\\build\\smz\\exportImport\\services\\UsersExportService",
            "permissions": []
        },
        "raise_rss_users": {
            "class": "app\\build\\smz\\exportImport\\services\\RaiseRssUsersExportService",
            "permissions": []
        },
        "raise_workers_users": {
            "class": "app\\build\\smz\\exportImport\\services\\RaiseWorkersUsersExportService",
            "permissions": []
        },
        "home_files": {
            "class": "app\\build\\smz\\exportImport\\services\\HomeFilesExportService",
            "permissions": []
        },
        "comp_plan": {
            "class": "app\\build\\smz\\exportImport\\services\\CompPlanExportService",
            "permissions": []
        }
    },
    "import": {
        "home_files": {
            "class": "app\\build\\smz\\exportImport\\services\\HomeFilesImportService",
            "permissions": []
        },
        "raise_rss_ranges_by_bands": {
            "class": "app\\build\\smz\\exportImport\\services\\CompensationProcedureRaiseRssRangesByBandsImportService",
            "permissions": [],
            "example": "RangesByBands.xlsx"
        },
        "raise_workers_ranges_by_bands": {
            "class": "app\\build\\smz\\exportImport\\services\\CompensationProcedureRaiseWorkersRangesByBandsImportService",
            "permissions": [],
            "example": "RangesByBands.xlsx"
        },
        "raise_workers_members": {
            "class": "app\\build\\smz\\exportImport\\services\\CompensationProcedureRaiseWorkersMembersImportService",
            "permissions": [],
            "example": "ProcedureMembers.xlsx"
        },
        "raise_rss_members": {
            "class": "app\\build\\smz\\exportImport\\services\\CompensationProcedureRaiseRssMembersImportService",
            "permissions": [],
            "example": "ProcedureMembers.xlsx"
        },
        "chiefs_import": {
            "class": "app\\build\\smz\\exportImport\\services\\ChiefsImportService",
            "permissions": [],
            "example": "chiefs.xlsx"
        }
    }
}